/* src/app/modules/stats/components/users-stats/users-stats-chart-tooltip/users-stats-chart-tooltip.component.scss */
pre {
  background-color: #FF5000;
  border-radius: 4%;
  color: white;
  font-family: "Open Sans";
  font-weight: 350;
  padding: 5px;
}
/*# sourceMappingURL=users-stats-chart-tooltip.component.css.map */
